<template>

    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row justify-content-between">
                <div class="d-none d-xl-block col-3">
                    <catalog-categories></catalog-categories>
                </div>

                <div class="col-md-6">
                    <h1 class="as-h2 mb-32">Вход</h1>
                    <h4 class="mb-64">Если вы уже являетесь нашим клиентом, то вам необходимо ввести номер телефона и восстановить пароль через кнопку "Забыли пароль". Если нет, то пройдите Регистрацию.</h4>
                    <div class="position-relative">

                        <div class="mb-32 input-box">

                            <label for="login_phone" :class="{'error-form': $v.login.$error}">Телефон*</label>

                            <input id="login_phone" type="text"
                                   placeholder="+"
                                   @input="delayTouch($v.login)"
                                   v-model.trim="login"
                                   v-on:keyup.enter="loginUser()"
                                   v-mask="'+################'">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте
                                    формат введенного номера.</div>
                                <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле
                                    обязательно для заполнения</div>
                            </div>
                        </div>

                        <div class="mb-32 input-box">
                            <label for="login_pass" :class="{'error-form': $v.password.$error}">Пароль*</label>
                            <input id="login_pass" type="password"
                                   @input="delayTouch($v.password)"
                                   v-on:keyup.enter="loginUser()"
                                   v-model.trim="password">
                            <div class="error-box">
                                <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.required">Поле
                                    обязательно для заполнения.</div>
                            </div>
                            <div class="h6 font-500 mb-0 pt-1">
                                <router-link to="/reset">Забыли пароль?</router-link>
                            </div>
                        </div>

                        <div class="mb-16">
                            <button id="voiti" class="button btn-large"
                                    @click="loginUser()">
                                Войти
                            </button>
                        </div>
                        <div class="h6 mb-0 font-500">
                            Еще нет аккаунта?
                            <router-link to="/register" class="text-underline">Зарегистрироваться</router-link>
                        </div>

                        <div v-if="loading" class="loading-box">
                            <b-spinner></b-spinner>
                        </div>

                    </div>
                </div>


                <div class="d-none d-md-block text-right col-5 col-lg-3">
                    <img :src="logoSvg" class="img-fluid"
                         alt="Фотопрокат MRental - прокат фото, видео и кинотехники в Минске без залога">
                </div>

            </div>
        </div>

    </div>

</template>


<script>
    import { phoneRule, requiredRule
    } from '../../../services/validation';

    const touchMap = new WeakMap();

    export default {

        data() {
            return {
                login: null,
                password: null,

                breadcrumb: [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: 'Вход',
                        active: true
                    }
                ],

                loading: false,

                logoSvg: require('./../../../../svg/logo-new-dark-2.svg'),
            }
        },

        methods: {
            loginUser() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;

                    let url = '/api/login';

                    let params = {
                        phone: this.login,
                        password: this.password,
                    };

                    axios.post(url, params)
                        .then(response => {
                            if (response.status == 200) {
                                if (response.data.access_token) localStorage.setItem('token', response.data.access_token);
                                // this.$store.dispatch('fetchUser');
                                window.location.pathname = "/account";
                            }
                        })
                        .catch(error => {
                            if (error) this.loading = false;
                        })
                }
            },


            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            },

            getSeoInfo(){
                let url = '/api/seo';

                let params = {
                    url: 'login',
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Вход в личный кабинет Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Войдите в личный кабинет на сайте Фотопроката "MRental" для контроля своих заказов и управление карточкой клиента.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            }

        },

        mounted(){
            this.getSeoInfo();
        },

        validations: {
            login: phoneRule,
            password: requiredRule
        }
    }
</script>
